import React, { useEffect, useRef } from 'react';
import { usePage } from '@inertiajs/inertia-react';

const MapDisplay = () => {
     const { data } = usePage().props;
     const googleMapRef = useRef();

     useEffect(() => {
          const googleMapScript = document.createElement('script');
          googleMapScript.src=`https://maps.googleapis.com/maps/api/js?key=${'AIzaSyBR3hWMipMRMEc8it4HQaP7Vm7isx8GPwQ'}&libraries=places&language=fr`;
          googleMapScript.async = true;
          window.document.body.appendChild(googleMapScript);
          googleMapScript.addEventListener('load', () => {createGoogleMap()});
     },[]);

     function createGoogleMap(){
          let googleMap = new window.google.maps.Map(googleMapRef.current, {
               zoom: 9,
               center: {lat: 18.95229370, lng: -72.70528250,},
               disableDefaultUI: true,
          });
          {data.map.map(({title, description, address, phone, lat, lon, marker},i)=>{
               let contentString = `<div key='marker${i}'>
                    <h2 className="text-gray-700 text-md font-medium">${title}</h2>
                    <div className="p-2 bg-gray-200 text-sm text-gray-600 rounded">
                         <p>${description}</p>
                         <p>${address}</p>
                         <p>${phone}</p>
                    </div>
               </div>`;

               let infowindow = new window.google.maps.InfoWindow({content: contentString});

               let position = {lat:parseFloat(lat), lng:parseFloat(lon)};
               let mapMarker = new window.google.maps.Marker({
                    position: position,
                    map: googleMap,
                    animation: window.google.maps.Animation.DROP,
                    title: `${title}`,
                    icon : marker,
               });
               mapMarker.addListener("click", () => {
                    infowindow.open(googleMap, mapMarker);
               });
          })}
     }

     return (
          <div id="google-map" ref={googleMapRef} style={{ width: '100%', height: '100%' }}/>
     );
}

export default MapDisplay;
